<template>
    <div class="pa-2 text-center">
      <v-dialog
        v-model="dialog"
        max-width="600"
      >
        <template v-slot:activator="{ props: activatorProps }">
          <v-btn color="primary" variant="flat" prepend-icon="mdi-account-multiple-plus" v-bind="activatorProps">New Team</v-btn>
        </template>
  
        <v-card
          prepend-icon="mdi-account-multiple-plus"
          title="Create Team"
        >
          <v-card-text>
            <v-row dense>
                <v-col
                cols="12"
                md="6"
                lg="6"
                sm="12"
              >
              <v-text-field
                    density="compact"
                    placeholder="Team name*"
                    prepend-inner-icon="mdi-information"
                    variant="outlined"
                    v-model="team_name"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="6"
                lg="6"
                sm="12"
              >
              <v-text-field
                    density="compact"
                    placeholder="Team description*"
                    prepend-inner-icon="mdi-card-account-details"
                    variant="outlined"
                    v-model="team_desc"
                ></v-text-field>
              </v-col>
            </v-row>
  
            <small class="text-caption text-medium-emphasis">*indicates required field</small>
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
  
            <v-btn
              text="Close"
              variant="plain"
              @click="dialog = false"
            ></v-btn>
  
            <v-btn
              color="primary"
              text="Save"
              variant="flat"
              @click="createTeam"
            ></v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  <script>
  import constant from '@/constant';
  import utils from '@/utils';
  import axios from 'axios';
    export default {
        name: "AddTeam",
      data: () => ({
        constant: constant,
        dialog: false,
        team_name: "",
        team_desc: "",
        message: ""
      }),
      methods: {
        createTeam(){
            const f = new FormData();
            f.append("team_name", this.team_name);
            f.append("team_desc", this.team_desc);
           axios.post(utils._api(this.constant.create_team),f , {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Authorization' : `Bearer ${localStorage.getItem('token')}`
                },
            }).then((response) => {
                this.isshow = !this.isshow;
                this.message = response.data.message;
                this.dialog = !this.dialog;
                this.team_name = "";
                this.team_desc = "";
                this.$emit('toggle-message', this.message);
                // setTimeout(() => {
                //     this.$router.push({ name: 'dashboard' });
                // }, 5000);
                console.log(this.message);
            });
        }
      }
    }
  </script>